import './app/publicPath'
import ShopTheLookBrowser from './app/components/ShopTheLook/ShopTheLookBrowser.vue'
import ShopTheLookItem from './app/components/ShopTheLook/ShopTheLookItem.vue'

const Vue = window.Vue

Vue.component('ShopTheLookBrowser', ShopTheLookBrowser)
Vue.component('ShopTheLookItem', ShopTheLookItem)
